/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AverageInputs */

const cs_enum_average = /** @type {(inputs: Enum_AverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Průměrný`)
};

const en_enum_average = /** @type {(inputs: Enum_AverageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average`)
};

/**
* | output |
* | --- |
* | "Average" |
*
* @param {Enum_AverageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_average = /** @type {((inputs?: Enum_AverageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AverageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_average(inputs)
	return cs_enum_average(inputs)
});